import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WorkflowStageEnum } from "utils/types";
import {
  setLearningRequestLifecycleLocal,
  clearLearningRequestLifecycleLocal,
} from "utils/helpers";
import { logger } from "utils/logger";

interface NewLearningRequestState {
  workflowStage: WorkflowStageEnum | null;
  isOpenSurveyRequested: boolean;
}

const initialState: NewLearningRequestState = {
  workflowStage: null,
  isOpenSurveyRequested: false,
};

export const newLearningRequestSlice = createSlice({
  name: "newLearningRequest",
  initialState,
  reducers: {
    setWorkflowStage(state, action: PayloadAction<WorkflowStageEnum | null>) {
      state.workflowStage = action.payload;
      try {
        if (action.payload) {
          setLearningRequestLifecycleLocal(action.payload);
        } else {
          clearLearningRequestLifecycleLocal();
        }
      } catch (e) {
        logger.warn("Failed to persist workflow stage to localStorage", {
          error: e instanceof Error ? e.message : String(e),
        });
      }
    },
    requestOpenSurvey(state) {
      state.isOpenSurveyRequested = true;
    },
    clearOpenSurveyRequest(state) {
      state.isOpenSurveyRequested = false;
    },
  },
});

export const { setWorkflowStage, requestOpenSurvey, clearOpenSurveyRequest } =
  newLearningRequestSlice.actions;

export default newLearningRequestSlice.reducer;
